/* import __COLOCATED_TEMPLATE__ from './facebook-restricted-replies-banner.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const FacebookRestrictedRepliesBanner = templateOnlyComponent<Signature>();
export default FacebookRestrictedRepliesBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::FacebookRestrictedRepliesBanner': typeof FacebookRestrictedRepliesBanner;
    'inbox2/facebook-restricted-replies-banner': typeof FacebookRestrictedRepliesBanner;
  }
}
